/**
 * Mixin to add standardized JSURL handling to a Panel app
 */
import {parseJsUrl, serializeJsUrl} from './util/url';

const JSURLMixin = (superclass) =>
  class extends superclass {
    /**
     * Panel route handler for JSURLized data. Attempts to repair common
     * link malformations by email clients. Expects component to implement
     * handleURLParamsUpdate() and handleInvalidURLParams().
     */
    handleJSURLRoute(stateUpdate = {}, rawJsURL) {
      const jsUrlInfo = parseJsUrl(rawJsURL);
      if (jsUrlInfo.valid) {
        if (jsUrlInfo.correctedUrl !== rawJsURL) {
          history.replaceState(null, null, `#${jsUrlInfo.correctedUrl}`);
          stateUpdate = {...stateUpdate, $fragment: jsUrlInfo.correctedUrl};
        }

        return {...stateUpdate, ...this.handleURLParamsUpdate(jsUrlInfo.data)};
      } else {
        this.navigate(``, {...stateUpdate, ...this.handleInvalidURLParams()});
      }
    }

    handleInvalidURLParams(): any | void {
      throw new Error(`Not implemented`);
    }

    handleURLParamsUpdate(_parsedURL): any | void {
      throw new Error(`Not implemented`);
    }

    /**
     * Serialize data and put in URL hash. Removes hash altogether if data is null/undefined.
     * @param {Object} urlData - data to serialize on URL
     */
    updateJSURL(urlData) {
      history.replaceState(null, null, `#${serializeJsUrl(urlData)}`);
    }
  };

export default JSURLMixin;
